import {EmptyState, Illustration} from '@sollapay/ui/components';
import {SearchIllustration} from '@sollapay/ui/illustrations';

import type {FC, ReactNode} from 'react';

export interface TrustAccountListEmptyProps {
  title: string;
  subtitle: string;
  action?: ReactNode;
}

/** The page-level empty state of an account list, shared by the member and guest screens. */
export const TrustAccountListEmpty: FC<TrustAccountListEmptyProps> = ({
  title,
  subtitle,
  action
}) => (
  <div data-slot="trust-account-list-empty" className="flex min-h-150 items-center justify-center">
    <EmptyState
      illustration={
        <Illustration width={166}>
          <SearchIllustration />
        </Illustration>
      }
      title={title}
      subtitle={subtitle}
      action={action}
    />
  </div>
);
